import { render, staticRenderFns } from "./InvestigationLabRequest.vue?vue&type=template&id=69d1feac&"
import script from "./InvestigationLabRequest.vue?vue&type=script&lang=js&"
export * from "./InvestigationLabRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports